// extracted by mini-css-extract-plugin
export default {"wrapper":"MainLayout_wrapper__MEvLv","contentWrapper":"MainLayout_contentWrapper__iJBSZ","childrenWrapper":"MainLayout_childrenWrapper__a5UqA"};